import { camelCase, isNumber, upperFirst } from "lodash";
import {
  PluginContainerData_Alignment as ALIGNMENT,
  PluginContainerData_Width_Type as SIZE
} from "./../../ricos-schema/legacy/wix/rich_content/v1";
import styles from "./../../wix-rich-content-common/statics/styles/general.rtlignore-scss";
const alignmentClassName = (node) => {
  const { alignment, width } = node.imageData?.containerData || {};
  if (!alignment) {
    return "";
  }
  let align = alignment;
  if (width?.size === SIZE.ORIGINAL && alignment !== ALIGNMENT.CENTER) {
    const { width: width2 } = node.imageData?.image || {};
    if (isNumber(width2) && width2 > 350) {
      align = ALIGNMENT.CENTER;
    }
  }
  return styles[`align${upperFirst(align.toLowerCase())}`];
};
const sizeClassName = (node, isMobile) => {
  const { width } = node.imageData?.containerData || {};
  if (!width?.size || isMobile && width?.size === SIZE.ORIGINAL) {
    return "";
  }
  return width?.size === SIZE.FULL_WIDTH ? styles.sizeFullWidth : styles[`size${upperFirst(camelCase(width.size.toLowerCase()))}`];
};
const textWrapClassName = (node) => {
  const { textWrap } = node.imageData?.containerData || {};
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
export {
  alignmentClassName,
  sizeClassName,
  textWrapClassName
};
//# sourceMappingURL=class-name-strategies.js.map
